<template>
  <v-app>
    <v-app-bar app color="primary" dark clipped-right>
      <v-toolbar-title>S I G M A</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-progress-circular v-if="loading" indeterminate color="#ffffff">
      </v-progress-circular>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-navigation-drawer
      app
      :clipped="!isMobile"
      :permanent="!isMobile"
      v-model="drawer"
      :right="!isMobile"
      :bottom="isMobile"
      width="400"
    >
      <v-list expand>
        <v-subheader>Opções de exibição</v-subheader>
        <v-list-group
          v-for="(group, i) in mapLayerGroups"
          :key="`layer-group-${i}`"
          v-model="group.show"
        >
          <template v-slot:activator>
            <v-list-item-action>
              <v-switch
                value
                v-model="group.show"
                readonly
                :color="`${group.color} darken-3`"
              >
              </v-switch>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ group.name }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <v-divider></v-divider>

          <v-list-item
            v-for="(layer, name) in group.layers"
            :key="`layer-${name}`"
            ripple
            @click="layer.show = !layer.show"
          >
            <v-list-item-action>
              <v-switch
                v-model="layer.show"
                readonly
                :color="`${group.color} darken-3`"
              >
              </v-switch>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-content app>
      <div class="fab-container">
        <v-container px-6 fluid>
          <v-row>
            <v-col class="py-1 text-center">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    v-on="on"
                    :small="isMobile"
                    elevation="2"
                    :disabled="zoom >= 18"
                    @click="zoom += 1"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Aproximar</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1 text-center">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    v-on="on"
                    :small="isMobile"
                    elevation="2"
                    :disabled="zoom <= minZoom"
                    @click="zoom -= 1"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </template>
                <span>Afastar</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row v-if="isMobile">
            <v-col class="py-1 text-center">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    v-on="on"
                    @click="drawer = true"
                    :large="isMobile"
                    color="primary"
                    elevation="4"
                  >
                    <v-icon>mdi-layers</v-icon>
                  </v-btn>
                </template>
                <span>Opções de exibição</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <div :style="`height: ` + (isMobile ? `10px` : `40px`)"></div>
        </v-container>
      </div>
      <Map
        :zoom.sync="zoom"
        :layer-groups.sync="mapLayerGroups"
        @update:loading="loading = $event"
      >
      </Map>
    </v-content>

    <v-footer padless app dark color="primary" class="hidden-sm-and-down">
      <v-card flat tile class="transparent text-center" width="100%">
        <v-card-text class="py-2">
          {{ new Date().getFullYear() }} —
          <strong>Pedro Daniel Gohl - CIACT / Miguel Felipe Lima - DMCA</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import Map from "./components/Map";

export default {
  name: "App",
  components: {
    Map
  },
  data: () => ({
    colorMenu: false,
    loading: false,
    mapLayerGroups: null,

    zoom: 7,
    minZoom: 7,

    icons: ["mdi-home", "mdi-email"],

    drawer: false,
    fav: true,
    menu: false,
    message: false,
    hints: true,
    fillColor: "#ff0000"
  }),

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }
};
</script>
<style>
.fab-container {
  z-index: 1;
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>